import { j as r } from "../accordion/Accordion-CrPiD_81.mjs";
const d = ({
  className: i = "",
  numberOfNotifications: t = 1,
  testid: o = "",
  large: a = !1,
  showNumber: s = !0,
  ...n
}) => /* @__PURE__ */ r.jsx(
  "span",
  {
    "data-testid": o,
    "aria-live": "polite",
    "aria-label": t === 1 ? "1 ny notifikasjon" : `${t} nye notifikasjoner`,
    className: `rds-notification-dot 
      rds-notification-dot--top-right 
      ${i} 
      ${a ? "rds-notification-dot--large" : ""}
    `,
    ...n,
    children: s ? t : ""
  }
);
export {
  d as N
};
